import React, { useState, useRef } from "react";
import { Card, Button } from "react-bootstrap";
import axios from "axios";
import useCookie from "../hooks/useCookie";

// This card is used in places like the Admin page and the Classroom page
// to display information about classes and allow for the editing of class information.

/**
 * Creates a card for the given class
 * @param {*} cls Class that the card is being created for
 * @param {*} handleUpdate Function to update the class list
 * @returns
 */
const ClassCard = ({ cls, handleUpdate }) => {
  const { classID, className, classGrade, teacher_id: teacher } = cls;
  const [isEditing, setIsEditing] = useState(false);
  const csrftoken = useCookie("csrftoken");

  const classNameRef = useRef();
  const classGradeRef = useRef();
  const teacherRef = useRef();

  const handleEdit = (e) => {
    e.preventDefault();
    setIsEditing(true);
  };

  /**
   * Handles saving the class
   * Using the ref to get the value of the input
   * @param {*} e
   */
  const handleSave = (e) => {
    const headers = {
      "X-CSRFToken": csrftoken,
    };

    // Weird part of this is the teachers and teacherID field. to make sure the correct ID
    // is being sent to the backend, we need to check if the user has changed the value
    // of the input. If they have, we need to send the new value. If they haven't, we need
    // to send the old value. This is because the backend is expecting an ID, not a name.
    const updatedClass = {
      className: classNameRef.current.value || classNameRef.current.placeholder,
      classGrade: classGradeRef.current.value || classGradeRef.current.placeholder,
      teacher: teacherRef.current.value || teacher,
    };
    axios
      .put(`/api/classes/${classID}/`, updatedClass, {
        headers,
      })
      .then(() => {
        setIsEditing(false);
        handleUpdate();
      })
      .catch((error) => console.error(error));
  };

  /**
   * Handles deleting the class
   * @param {*} e
   */
  const deleteClass = (e) => {
    e.preventDefault();
    const headers = {
      "X-CSRFToken": csrftoken,
    };
    axios
      .delete(`/api/classes/${classID}/`, { headers })
      .then(() => {
        //Refresh to get new data
        window.location.reload();
      })
      .catch((error) => console.error(error));
  };

  return (
    <Card className="my-2">
      <Card.Header className="d-flex justify-content-between">
        <Card.Title>{className}</Card.Title>
        {isEditing ? (
          <div>
            <Button variant="danger" onClick={deleteClass}>
              Delete
            </Button>
            <Button variant="danger" onClick={() => setIsEditing(false)}>
              Cancel
            </Button>
            <Button onClick={handleSave}>Save</Button>
          </div>
        ) : (
          <Button className = "admin-button" onClick={handleEdit}>Edit</Button>
        )}
      </Card.Header>
      <Card.Body>
        {isEditing ? (
          <div className="edit-info">
            <div>
              <p>Class name</p>
              <input type="text" placeholder={className} ref={classNameRef} />
            </div>
            <div>
              <p>Class grade</p>
              <input type="text" placeholder={classGrade} ref={classGradeRef} />
            </div>
            <div>
              <p>Teacher ID</p>
              <input type="text" placeholder={teacher} ref={teacherRef} />
            </div>
          </div>
        ) : (
          <div>
            <Card.Text>ID: {classID}</Card.Text>
            <Card.Text>Grade: {classGrade}</Card.Text>
            <Card.Text>Teacher ID: {teacher}</Card.Text>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

/**
 * Prints all the classes
 * @returns
 */
const ClassList = ({ classes }) => {
  // Refresh to get new data
  const handleUpdate = (updatedStudent) => {
    window.location.reload();
  };

  return (
    <div>
      {classes.map((cls) => (
        <ClassCard key={cls.id} cls={cls} handleUpdate={handleUpdate} />
      ))}
    </div>
  );
};

export default ClassList;
